import { render, staticRenderFns } from "./subAccount.vue?vue&type=template&id=34209a6a&scoped=true&"
import script from "./subAccount.vue?vue&type=script&lang=js&"
export * from "./subAccount.vue?vue&type=script&lang=js&"
import style0 from "./subAccount.vue?vue&type=style&index=0&id=34209a6a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34209a6a",
  null
  
)

export default component.exports